var i18n = require('i18n');
module.exports = function(key) {
    return i18n(key);
};


// WEBPACK FOOTER //
// ./helpers/i18n.js